import axios from 'axios';

const API = process.env.NODE_ENV === 'production' ? '/api' : `${process.env.REACT_APP_BACKEND_URL}/api`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Dashboard
export const getDashboardStats = async () => {
  const response = await axios.get(`${API}/dashboard/stats`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

// API Tokens
export const getApiTokens = async () => {
  const response = await axios.get(`${API}/tokens`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const createApiToken = async (provider, token) => {
  const response = await axios.post(`${API}/tokens`, { provider, token }, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const deleteApiToken = async (provider) => {
  const response = await axios.delete(`${API}/tokens/${provider}`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

// Back Market Orders
export const getBackMarketOrders = async (state = null, page = 1, pendingInvoice = false, perPage = 10) => {
  const params = new URLSearchParams({ page: page.toString(), per_page: perPage.toString() });
  if (pendingInvoice) {
    params.append('pending_invoice', 'true');
  } else if (state) {
    params.append('state', state);
  }
  
  const response = await axios.get(`${API}/backmarket/orders?${params}`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const getBackMarketOrder = async (orderId) => {
  const response = await axios.get(`${API}/backmarket/orders/${orderId}`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

// Back Market Listings
export const getBackMarketListings = async (page = 1, sku = null) => {
  const params = new URLSearchParams({ page: page.toString() });
  if (sku) params.append('sku', sku);
  
  const response = await axios.get(`${API}/backmarket/listings?${params}`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const getAllBackMarketListings = async () => {
  const response = await axios.get(`${API}/backmarket/listings/all`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const saveListingPrices = async (listingId, priceData) => {
  const response = await axios.post(`${API}/listings/${listingId}/prices`, priceData, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const searchArgus = async (query) => {
  const response = await axios.get(`${API}/argus/search`, {
    params: { q: query, per_page: 250 },
    headers: getAuthHeaders()
  });
  return response.data;
};

export const getArgusCatalog = async () => {
  const response = await axios.get(`${API}/argus/catalog`, { headers: getAuthHeaders() });
  return response.data;
};

export const refreshArgusCatalog = async () => {
  const response = await axios.post(`${API}/argus/refresh`, {}, { headers: getAuthHeaders() });
  return response.data;
};

export const getArgusRefreshStatus = async () => {
  const response = await axios.get(`${API}/argus/refresh-status`, { headers: getAuthHeaders() });
  return response.data;
};

export const getArgusHistory = async (model, storage) => {
  const params = { model };
  if (storage) params.storage = storage;
  const response = await axios.get(`${API}/argus/history`, { params, headers: getAuthHeaders() });
  return response.data;
};

export const forceArgusSnapshot = async () => {
  const response = await axios.post(`${API}/argus/snapshot`, {}, { headers: getAuthHeaders() });
  return response.data;
};




export const updateBackMarketListing = async (listingId, updateData) => {
  const response = await axios.put(`${API}/backmarket/listings/${listingId}`, updateData, {
    headers: getAuthHeaders()
  });
  return response.data;
};

// Back Market Categories
export const getBackMarketCategories = async () => {
  const response = await axios.get(`${API}/backmarket/categories`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

// Invoices
export const getInvoices = async () => {
  const response = await axios.get(`${API}/invoices`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const getInvoice = async (invoiceId) => {
  const response = await axios.get(`${API}/invoices/${invoiceId}`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const createInvoice = async (invoiceData) => {
  const response = await axios.post(`${API}/pennylane/invoices`, invoiceData, {
    headers: getAuthHeaders()
  });
  return response.data;
};

// Send invoice to Back Market (DISABLED - will be enabled later)
export const sendInvoiceToBackMarket = async (orderId, invoiceId) => {
  const response = await axios.post(`${API}/backmarket/orders/${orderId}/send-invoice?invoice_id=${invoiceId}`, {}, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const sendInvoiceToBM = async (orderId, invoiceId) => {
  const response = await axios.post(`${API}/backmarket/orders/${orderId}/send-invoice?invoice_id=${invoiceId}`, {}, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const getInvoicePdfUrl = async (orderId) => {
  const response = await axios.get(`${API}/invoices/${orderId}/pdf`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const markInvoiceSent = async (orderId) => {
  const response = await axios.put(`${API}/invoices/${orderId}/mark-sent`, {}, {
    headers: getAuthHeaders()
  });
  return response.data;
};

// Subscriptions
export const getSubscriptionPlans = async () => {
  const response = await axios.get(`${API}/subscription/plans`);
  return response.data;
};

// User Preferences
export const getUserPreferences = async () => {
  const response = await axios.get(`${API}/user/preferences`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const updateUserPreferences = async (prefs) => {
  const response = await axios.put(`${API}/user/preferences`, prefs, {
    headers: getAuthHeaders()
  });
  return response.data;
};

// API Keys
export const generateApiKey = async (data) => {
  const response = await axios.post(`${API}/api-keys/generate`, data, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const getApiKeys = async () => {
  const response = await axios.get(`${API}/api-keys`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const revokeApiKey = async (keyId) => {
  const response = await axios.delete(`${API}/api-keys/${keyId}`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

// ERP Sync
export const syncInvoiceToErp = async (orderId) => {
  const response = await axios.post(`${API}/invoices/${orderId}/sync-erp`, {}, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const createSubscriptionCheckout = async (plan) => {
  const originUrl = window.location.origin;
  const response = await axios.post(`${API}/subscription/checkout`, { plan, origin_url: originUrl }, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const getSubscriptionStatus = async (sessionId) => {
  const response = await axios.get(`${API}/subscription/status/${sessionId}`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

// BuyBack (Trade-In)
export const getBuybackOrders = async (page = 1, pageSize = 20, status = null) => {
  const params = { page, pageSize };
  if (status) params.status = status;
  const response = await axios.get(`${API}/buyback/orders`, { headers: getAuthHeaders(), params });
  return response.data;
};

export const getBuybackPending = async () => {
  const response = await axios.get(`${API}/buyback/orders/pending`, { headers: getAuthHeaders() });
  return response.data;
};

export const getBuybackOrder = async (orderId) => {
  const response = await axios.get(`${API}/buyback/orders/${orderId}`, { headers: getAuthHeaders() });
  return response.data;
};

export const getBuybackOrderMessages = async (orderId) => {
  const response = await axios.get(`${API}/buyback/orders/${orderId}/messages`, { headers: getAuthHeaders() });
  return response.data;
};

export const sendBuybackMessage = async (orderId, message) => {
  const response = await axios.post(`${API}/buyback/orders/${orderId}/messages`, { message }, { headers: getAuthHeaders() });
  return response.data;
};

export const validateBuybackOrder = async (orderId) => {
  const response = await axios.put(`${API}/buyback/orders/${orderId}/validate`, {}, { headers: getAuthHeaders() });
  return response.data;
};

export const suspendBuybackOrder = async (orderId, reason, message) => {
  const response = await axios.put(`${API}/buyback/orders/${orderId}/suspend`, { reason, message }, { headers: getAuthHeaders() });
  return response.data;
};

export const counterOfferBuyback = async (orderId, price, reason, message) => {
  const response = await axios.put(`${API}/buyback/orders/${orderId}/counter-offer`, { price, reason, message }, { headers: getAuthHeaders() });
  return response.data;
};

export const getBuybackSuspendReasons = async () => {
  const response = await axios.get(`${API}/buyback/suspend-reasons`, { headers: getAuthHeaders() });
  return response.data;
};

export const getAllBuybackListings = async () => {
  const response = await axios.get(`${API}/buyback/listings/all`, { headers: getAuthHeaders() });
  return response.data;
};

export const updateBuybackListing = async (listingId, data) => {
  const response = await axios.put(`${API}/buyback/listings/${listingId}`, data, { headers: getAuthHeaders() });
  return response.data;
};

// Buyback Tags
export const getBuybackTags = async () => {
  const response = await axios.get(`${API}/buyback/tags`, { headers: getAuthHeaders() });
  return response.data;
};
export const createBuybackTag = async (name, color) => {
  const response = await axios.post(`${API}/buyback/tags`, { name, color }, { headers: getAuthHeaders() });
  return response.data;
};
export const deleteBuybackTag = async (tagId) => {
  const response = await axios.delete(`${API}/buyback/tags/${tagId}`, { headers: getAuthHeaders() });
  return response.data;
};
export const assignTagToProducts = async (tagId, productIds) => {
  const response = await axios.post(`${API}/buyback/products/tags`, { tag_id: tagId, product_ids: productIds }, { headers: getAuthHeaders() });
  return response.data;
};
export const removeTagFromProduct = async (productId, tagId) => {
  const response = await axios.delete(`${API}/buyback/products/${productId}/tags/${tagId}`, { headers: getAuthHeaders() });
  return response.data;
};
export const getAllProductTags = async () => {
  const response = await axios.get(`${API}/buyback/products/tags`, { headers: getAuthHeaders() });
  return response.data;
};


export const setBuybackProductName = async (productId, name) => {
  const response = await axios.put(`${API}/buyback/product-name/${productId}`, { name }, { headers: getAuthHeaders() });
  return response.data;
};

export const scanBuybackProductNames = async () => {
  const response = await axios.post(`${API}/buyback/scan-product-names`, {}, { headers: getAuthHeaders() });
  return response.data;
};

export const getKnownBuybackProducts = async () => {
  const response = await axios.get(`${API}/buyback/known-products`, { headers: getAuthHeaders() });
  return response.data;
};

export const getBuybackDashboard = async () => {
  const response = await axios.get(`${API}/buyback/dashboard`, { headers: getAuthHeaders() });
  return response.data;
};

export const getBuybackPurchaseHistory = async () => {
  const response = await axios.get(`${API}/buyback/purchase-history`, { headers: getAuthHeaders() });
  return response.data;
};

export const downloadBuybackCertificate = async (orderId) => {
  const response = await axios.get(`${API}/buyback/orders/${orderId}/certificate`, {
    headers: getAuthHeaders(),
    responseType: 'blob'
  });
  return response.data;
};

export const syncBuybackCertificates = async () => {
  const response = await axios.post(`${API}/buyback/certificates/sync`, {}, { headers: getAuthHeaders() });
  return response.data;
};

export const getCertificatesStatus = async () => {
  const response = await axios.get(`${API}/buyback/certificates/status`, { headers: getAuthHeaders() });
  return response.data;
};

export const resetAllErpErrors = async () => {
  const response = await axios.post(`${API}/invoices/reset-all-erp-errors`, {}, { headers: getAuthHeaders() });
  return response.data;
};

export const getArgusQueries = async () => {
  const response = await axios.get(`${API}/argus/queries`, { headers: getAuthHeaders() });
  return response.data;
};
export const addArgusQuery = async (query) => {
  const response = await axios.post(`${API}/argus/queries`, { query }, { headers: getAuthHeaders() });
  return response.data;
};
export const removeArgusQuery = async (query) => {
  const response = await axios.delete(`${API}/argus/queries`, { headers: getAuthHeaders(), data: { query } });
  return response.data;
};
export const getArgusManualPrices = async () => {
  const response = await axios.get(`${API}/argus/manual-prices`, { headers: getAuthHeaders() });
  return response.data;
};
export const upsertArgusManualPrice = async (data) => {
  const response = await axios.post(`${API}/argus/manual-prices`, data, { headers: getAuthHeaders() });
  return response.data;
};
export const deleteArgusManualPrice = async (model, storage) => {
  const response = await axios.delete(`${API}/argus/manual-prices`, { headers: getAuthHeaders(), data: { model, storage } });
  return response.data;
};

export const getPhoneB2BConfig = async () => {
  const response = await axios.get(`${API}/argus/phoneb2b-config`, { headers: getAuthHeaders() });
  return response.data;
};
export const getModelsWithoutArgus = async () => {
  const response = await axios.get(`${API}/argus/models-without-argus`, { headers: getAuthHeaders() });
  return response.data;
};

// Model Mappings (Phone B2B ↔ Argus)
export const getModelMappings = async () => {
  const response = await axios.get(`${API}/argus/mappings`, { headers: getAuthHeaders() });
  return response.data;
};
export const upsertModelMapping = async (data) => {
  const response = await axios.post(`${API}/argus/mappings`, data, { headers: getAuthHeaders() });
  return response.data;
};
export const deleteModelMapping = async (pb2b_model, pb2b_storage) => {
  const response = await axios.delete(`${API}/argus/mappings`, { headers: getAuthHeaders(), data: { pb2b_model, pb2b_storage } });
  return response.data;
};


export const getCounterOfferReasons = async () => {
  const response = await axios.get(`${API}/buyback/counter-offer-reasons`, { headers: getAuthHeaders() });
  return response.data;
};

export const debugBmApiTest = async () => {
  const response = await axios.get(`${API}/debug/bm-api-test`, { headers: getAuthHeaders() });
  return response.data;
};


// CompareCycle
export const getCompareCycleConfig = async () => {
  const response = await axios.get(`${API}/comparecycle/config`, { headers: getAuthHeaders() });
  return response.data;
};
export const getCompareCycleTransactions = async () => {
  const response = await axios.get(`${API}/comparecycle/transactions`, { headers: getAuthHeaders() });
  return response.data;
};
export const getCompareCycleCatalog = async () => {
  const response = await axios.get(`${API}/comparecycle/catalog`, { headers: getAuthHeaders() });
  return response.data;
};
export const getCompareCycleProduct = async (idproduct) => {
  const response = await axios.get(`${API}/comparecycle/product/${idproduct}`, { headers: getAuthHeaders() });
  return response.data;
};
export const setCompareCyclePrices = async (productList) => {
  const response = await axios.post(`${API}/comparecycle/set-prices`, { product_list: productList }, { headers: getAuthHeaders() });
  return response.data;
};
export const confirmCompareCyclePrices = async (actionsList) => {
  const response = await axios.post(`${API}/comparecycle/confirm-prices`, { actions_list: actionsList }, { headers: getAuthHeaders() });
  return response.data;
};
export const getCompareCycleBidHistory = async () => {
  const response = await axios.get(`${API}/comparecycle/bid-history`, { headers: getAuthHeaders() });
  return response.data;
};
export const getCompareCycleLostPositions = async () => {
  const response = await axios.get(`${API}/comparecycle/lost-positions`, { headers: getAuthHeaders() });
  return response.data;
};

export const getCompareCyclePriceHistory = async (productId, days = 30) => {
  const response = await axios.get(`${API}/comparecycle/price-history`, {
    params: { product_id: productId, days },
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const getCompareCycleDailyMetrics = async (days = 30) => {
  const response = await axios.get(`${API}/comparecycle/daily-metrics`, {
    params: { days },
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const getCompareCycleTransactionsCategorized = async () => {
  const response = await axios.get(`${API}/comparecycle/transactions/categorized`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const runCompareCycleSnapshotNow = async () => {
  const response = await axios.post(`${API}/comparecycle/snapshot/run-now`, {}, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const getCompareCycleSelections = async () => {
  const response = await axios.get(`${API}/comparecycle/selections`, { headers: getAuthHeaders() });
  return response.data;
};

export const saveCompareCycleSelection = async (name, productIds) => {
  const response = await axios.post(`${API}/comparecycle/selections`,
    { name, product_ids: productIds },
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const deleteCompareCycleSelection = async (name) => {
  const response = await axios.delete(`${API}/comparecycle/selections/${encodeURIComponent(name)}`, { headers: getAuthHeaders() });
  return response.data;
};


// Auto-publication ERP -> Back Market
export const getAutopubBoard = async (status = null) => {
  const params = status ? `?status=${status}` : '';
  const response = await axios.get(`${API}/autopub/board${params}`, { headers: getAuthHeaders() });
  return response.data;
};

export const updateAutopubItem = async (itemId, data) => {
  const response = await axios.put(`${API}/autopub/items/${itemId}`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const publishAutopubItem = async (itemId) => {
  const response = await axios.post(`${API}/autopub/items/${itemId}/publish`, {}, { headers: getAuthHeaders() });
  return response.data;
};

export const removeAutopubBm = async (itemId) => {
  const response = await axios.post(`${API}/autopub/items/${itemId}/remove-bm`, {}, { headers: getAuthHeaders() });
  return response.data;
};

export const deleteAutopubItem = async (itemId) => {
  const response = await axios.delete(`${API}/autopub/items/${itemId}`, { headers: getAuthHeaders() });
  return response.data;
};

export const autopubReindexCatalog = async () => {
  const response = await axios.post(`${API}/autopub/catalog/reindex`, {}, { headers: getAuthHeaders() });
  return response.data;
};

export const autopubCatalogStatus = async () => {
  const response = await axios.get(`${API}/autopub/catalog/status`, { headers: getAuthHeaders() });
  return response.data;
};

export const autopubCatalogSearch = async (q) => {
  const response = await axios.get(`${API}/autopub/catalog/search?q=${encodeURIComponent(q)}`, { headers: getAuthHeaders() });
  return response.data;
};

export const autopubRunWatchNow = async () => {
  const response = await axios.post(`${API}/autopub/watch/run-now`, {}, { headers: getAuthHeaders() });
  return response.data;
};

// Webhook ERP config
export const saveWebhookConfig = async (config) => {
  const response = await axios.put(`${API}/user/webhook-config`, config, { headers: getAuthHeaders() });
  return response.data;
};

export const testErpWebhook = async () => {
  const response = await axios.post(`${API}/user/webhook-config/test`, {}, { headers: getAuthHeaders() });
  return response.data;
};

export const autopubRefreshBuybox = async () => {
  const response = await axios.post(`${API}/autopub/buybox/refresh`, {}, { headers: getAuthHeaders() });
  return response.data;
};

